import * as React from "react";
import { Button, downloadCSV, useNotify } from "react-admin";
import DownloadIcon from "@mui/icons-material/Download";
import jsonExport from "jsonexport/dist";

export const UserListExportButton = () => {
	const notify = useNotify();

	const handleClick = () => {
		fetch(`/api/users/export`)
			.then((response) => response.json())
			.then((data) => {
				jsonExport(data, {}, (err: any, csv: string) => {
					if (err) {
						console.error(err);
						notify("ra.notification.http_error", { type: "warning" });
						return;
					}

					downloadCSV(csv, "users");
				});
			})
			.catch((e) => {
				console.error(e);
				notify("ra.notification.http_error", { type: "warning" });
			});
	};

	return (
		<Button label="ra.action.export" onClick={handleClick}>
			<DownloadIcon />
		</Button>
	);
};
